import React from 'react';
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	LabelList,
	ResponsiveContainer,
} from 'recharts';
import Title from './Title';

const renderCustomizedLabel = (props) => {
	const { x, y, width, id } = props;
	const radius = 10;

	return (
		<g>
			<circle
				cx={x + width / 2}
				cy={y - radius}
				r={radius}
				fill='#82ca9d'
			/>
			<text
				fontSize={'13px'}
				x={x + width / 2}
				y={y - radius}
				fill='#fff'
				textAnchor='middle'
				dominantBaseline='middle'
			>
				{id}
			</text>
		</g>
	);
};

export const BarChartDash = ({ data, currentMonth, lastMonth }) => {
	return (
		<>
			<Title>
				Pedidos creados ({lastMonth} vs {currentMonth})
			</Title>
			<ResponsiveContainer width='100%' height='100%'>
				<BarChart
					width={500}
					height={300}
					data={data}
					margin={{
						top: 5,
						right: 30,
						left: 20,
						bottom: 5,
					}}
				>
					<CartesianGrid strokeDasharray='3 3' />
					<XAxis dataKey='code' />
					<YAxis />
					<Tooltip />
					<Bar dataKey='Anterior' fill='#8884d8' minPointSize={5} />
					<Bar dataKey='Actual' fill='#82ca9d' minPointSize={10}>
						<LabelList
							dataKey='name'
							content={renderCustomizedLabel}
						/>
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		</>
	);
};
